import { Configuration } from 'ohzi-core';
import Utils from '/js/core/Utils';

import ApplicationView from '../common/ApplicationView';
import CollapsibleContainer from '../common/CollapsibleContainer';
import { SdrReceiver } from './SdrReceiver';

/**
 *  @class UavView
 *  @description This class is responsible for the display of the UAV controls and status
 */

// This represents the drone panel that contains the UAV status and controls
class PharosView extends ApplicationView
{
  constructor(app)
  {
    super('pharos', $('.pharos'));

    this.app = app;
    this.is_opened = false;
    // this.alt_change_request_time = 0;
    this.follow_state = false;
    this.follow_auto_target_state = false;
    this.pharos_enable_state = false;
    this.pharos_sim_state = true;
    this.nested_click = false;
    this.selected_target_source = undefined;

    this.sdr_status = undefined;
    this.sdr_initial_receieve = false;
    // this.elapsed_time = 0;

    this.radar_system_state_enum = {
      0: 'Reset',
      1: 'Init',
      2: 'Idle',
      3: 'Command Executing',
      4: 'Search <- Desired end state if Search Mode',
      5: 'SWT <- Desired end state if SWT Mode',
      6: 'Error',
      7: 'Upgrade',
      8: 'Restart',
      9: 'Interference Detection'
    };

    this.sdr_receivers_container = document.querySelector('.pharos__sdr-receivers-container');
    this.sdr_receivers = [];
  }

  start()
  {
    this.pharos_container = $('.pharos__container');
    this.close_button = $('.pharos__buttons-close');
    this.open_button = $('.pharos__buttons-open');
    this.menu_handle = $('.pharos__handle');

    if (true)
    {
      this.enable_view();
    }
    else
    {
      this.disable_view();
    }

    this.target_source_select = $('.pharos__target-source-select');

    this.pharos_status_el           = this.container.find('.pharos__body-status')[0];
    this.pharos_status_base_el      = this.container.find('.pharos__body-status__base')[0];
    this.pharos_status_target_el    = this.container.find('.pharos__body-status__target')[0];
    this.pharos_status_rssi_el      = this.container.find('.pharos__body-status__rssi')[0];

    this.btn_follow                 = $('.pharos__button.set-follow')[0];
    this.btn_follow_auto_target     = $('.pharos__button.set-follow-auto-target')[0];
    this.btn_sdr_start              = $('.pharos__button__sdr-start');
    this.btn_sdr_stop               = $('.pharos__button__sdr-stop');

    this.sdr_body_el                = this.container.find('.pharos__body-sdr__body');
    this.sdr_transmitting_icon_el   = $('.pharos__title-text__SDR-transmitting');
    this.sdr_transmitting_indicator_el = $('.pharos__SDR-transmitting-indicator');
    this.sdr_online_el              = this.container.find('.pharos__body-sdr__status-online')[0];
    this.sdr_transmitting_el        = this.container.find('.pharos__body-sdr__status-transmitting')[0];

    this.control_inputs_el          = this.container.find('.pharos__body-sdr__control-inputs');
    this.input_sdr_freq             = $('.drone__body-controls__input__sdr-freq')[0];
    this.input_sdr_iqrate           = $('.drone__body-controls__input__sdr-iqrate')[0];
    this.input_sdr_gain             = $('.drone__body-controls__input__sdr-gain')[0];

    this.input_radar_yaw_offset     = $('.pharos__body-inputs__radar-yaw-offset')[0];
    this.input_radar_yaw_offset_range = $('.pharos__body-inputs__radar-yaw-offset-range')[0];
    this.input_radar_yaw_offset.addEventListener('input', this.update_radar_yaw_offset.bind(this, this.input_radar_yaw_offset));
    this.input_radar_yaw_offset_range.addEventListener('input', this.update_radar_yaw_offset.bind(this, this.input_radar_yaw_offset_range));

    this.radar_status_el            = this.container.find('.pharos__body-radar__status')[0];
    this.radar_scanning_el          = this.container.find('.pharos__body-radar__status-scanning')[0];
    this.radar_track_filter_uav     = this.container.find('.radar-track-filter-uav')[0];
    this.radar_track_filter_aircraft = this.container.find('.radar-track-filter-aircraft')[0];
    this.radar_track_filter_vehicle = this.container.find('.radar-track-filter-vehicle')[0];
    this.radar_track_filter_walker  = this.container.find('.radar-track-filter-walker')[0];
    this.radar_track_filter_bird    = this.container.find('.radar-track-filter-bird')[0];
    this.radar_track_filter_clutter = this.container.find('.radar-track-filter-clutter')[0];
    this.radar_track_filter_other   = this.container.find('.radar-track-filter-other')[0];

    this.radar_track_filter_uav_count       = this.container.find('.radar-track-filter-uav-count')[0];
    this.radar_track_filter_aircraft_count  = this.container.find('.radar-track-filter-aircraft-count')[0];
    this.radar_track_filter_vehicle_count   = this.container.find('.radar-track-filter-vehicle-count')[0];
    this.radar_track_filter_walker_count    = this.container.find('.radar-track-filter-walker-count')[0];
    this.radar_track_filter_bird_count      = this.container.find('.radar-track-filter-bird-count')[0];
    this.radar_track_filter_clutter_count   = this.container.find('.radar-track-filter-clutter-count')[0];
    this.radar_track_filter_other_count     = this.container.find('.radar-track-filter-other-count')[0];

    this.input_toggle_pharos_enable = document.querySelector('.pharos__options-item--toggle-enable');
    this.input_toggle_sim_enable    = document.querySelector('.pharos__options-item--toggle-sim');

    this.pharos_controller_container = new CollapsibleContainer('Pharos Controller', $('.pharos__body-pharos-controller__container'));
    this.radar_container = new CollapsibleContainer('Radar', $('.pharos__body-radar__container'));
    this.sdr_emitter_container = new CollapsibleContainer('SDR Emitter Control', $('.pharos__body-sdr-emitter__container'));
    this.sdr_receiver_container = new CollapsibleContainer('SDR Receiver Control', $('.pharos__body-sdr-receiver__container'));

    if (!Configuration.is_mobile && !this.app.mode_multi_camera)
    {
      // Disable by default. Check uiShowOptions parameters from Tracker App
      this.container.css('width', localStorage.getItem('pharos_width'));
    }

    this.menu_handle.on('mousedown touchstart', this.__on_mouse_down.bind(this));

    // Do other actions here

    this.demo_load_state();
  }

  demo_load_state(sim = true)
  {
    const pharos_option_enabled = true;
    const sdr_emitter_option_enabled = true;
    const sdr_receiver_option_enabled = true;
    const radar_option_enabled = true;

    this.enable_view();

    if (pharos_option_enabled)
    {
      this.enable_pharos_view();
    }
    else
    {
      this.disable_pharos_view();
    }

    if (sdr_emitter_option_enabled)
    {
      this.enable_sdr_emitter_view();
    }

    if (sdr_receiver_option_enabled)
    {
      this.enable_sdr_receiver_view();
    }

    if (radar_option_enabled)
    {
      this.enable_radar_view();
    }

    const demo_pharos = {
      current_pos: {
        lat: 39.4183429,
        lon: -76.6141505,
        alt: 276.01,
        heading: 176.43,
        pitch: -0.24,
        roll: -0.25,
        yaw: 145.8,
        gps_fix_type: 3,
        rtk_fix_type: 2,
        rel_pos_heading_valid: true,
        rel_pos_length: 10,
        rel_pos_heading: 215
      },
      selected_target: 'test_taglock',
      target_pos: {
        lat: 39.4183429,
        lon: -76.6141505,
        alt: 276.01
      },
      abs_bearing: 215,
      rel_yaw: 123,
      activated_zone: 1,
      distance: 55.4,
      // adsb_vehicles_in_sdr_zone: false,
      target_source: 'manual',
      omni_enable: true
    };

    const demo_sdr = {
      connected: true,
      online: true,
      freq: 1200000,
      iqrate: 200000,
      modulation: 'FM',
      gain: 10,
      transmitting: true,
      gpio12: true
    };

    const demo_radar = {
      connected: true,
      radar_connected: true,
      system_state: 4,
      radar_running: true,
      mode: 'rec',
      available: true,
      track_class_count: {
        CL_UAV: 2
      }
    };

    if (sim)
    {
      this.pharos_controller_container.set_online();
      this.sdr_receiver_container.set_online();
      this.update_status(demo_pharos);
      this.handle_sdr_status(demo_sdr);
      this.handle_radar_status(demo_radar);
    }
    else
    {
      // demo_pharos.connected = false;
      demo_sdr.connected = false;
      demo_radar.connected = false;
      this.pharos_controller_container.set_offline();
      this.radar_container.set_offline();
      this.sdr_emitter_container.set_offline();
      this.sdr_receiver_container.set_offline();
    }
  }

  update()
  {
    // Monitor if any menus are open then move the pharos icon
    if (this.app.uav_view.is_opened)
    {
      this.open_button.css('right', '-470px');
    }
    else if (this.app.menu_view.is_opened)
    {
      this.open_button.css('right', '-200px');
    }
    else
    {
      this.open_button.css('right', '-130px');
    }

    // Flash SDR Transmitting if active
    const now_ms = new Date().getTime();
    const toggle_state = now_ms % 2000 < 1000;
    if (this.sdr_status?.transmitting && toggle_state)
    {
      // this.sdr_transmitting_icon_el.removeClass('hidden');
      this.sdr_transmitting_indicator_el.removeClass('hidden');
      this.btn_sdr_start.removeClass('active');
    }
    else
    {
      // this.sdr_transmitting_icon_el.addClass('hidden');
      this.sdr_transmitting_indicator_el.addClass('hidden');
      this.btn_sdr_start.addClass('active');
    }
  }

  enable_view()
  {
    this.pharos_container.removeClass('hidden');
  }

  disable_view()
  {
    this.pharos_container.addClass('hidden');
  }

  enable_pharos_view()
  {
    this.pharos_controller_container.show();
    this.pharos_controller_container.open();
  }

  disable_pharos_view()
  {
    this.pharos_controller_container.hide();
  }

  enable_sdr_emitter_view()
  {
    this.sdr_emitter_container.show();
  }

  enable_sdr_receiver_view()
  {
    this.sdr_receiver_container.show();
  }

  enable_radar_view()
  {
    this.radar_container.show();
  }

  // Closes the menu panel
  close()
  {
    if (!this.app.menu_options_view.keep_menu_visible)
    {
      this.is_opened = false;
      this.container.addClass('closed');
    }
  }

  // Opens the menu panel
  open()
  {
    // Close other menus
    this.app.uav_view.close();
    this.app.menu_view.close();

    this.is_opened = true;
    this.container.removeClass('closed');

    // Do other actions here
  }

  // Called by UI (pharos.pug) when the user clicks the button
  toggle_pharos_enable()
  {
    this.pharos_enable_state = !this.pharos_enable_state;

    console.log(`[toggle_pharos_enable] sim_enable_state: ${this.pharos_enable_state}`);

    if (this.pharos_enable_state)
    {
      this.__toggle_switch_elem(this.input_toggle_pharos_enable, true);
    }
    else
    {
      this.__toggle_switch_elem(this.input_toggle_pharos_enable, false);
    }
  }

  // Called by UI (pharos.pug) when the user clicks the button
  toggle_sim_enable()
  {
    this.pharos_sim_state = !this.pharos_sim_state;

    console.log(`[toggle_sim_enable] pharos_sim_state: ${this.pharos_sim_state}`);

    if (this.pharos_sim_state)
    {
      this.__toggle_switch_elem(this.input_toggle_sim_enable, true);
      this.clear_data();
    }
    else
    {
      this.__toggle_switch_elem(this.input_toggle_sim_enable, false);
      this.clear_data();
    }
    this.demo_load_state(this.pharos_sim_state);
  }

  clear_data()
  {
    this.pharos_status_base_el.innerHTML = 'Waiting for data...';
    this.pharos_status_target_el.innerHTML = 'Waiting for data...';
  }

  // Return true if the track type is selected.
  is_radar_track_selected(type)
  {
    if (type.toLowerCase().includes('uav'))
    {
      return this.radar_track_filter_uav.checked;
    }
    else if (type.toLowerCase().includes('aircraft'))
    {
      return this.radar_track_filter_aircraft.checked;
    }
    else if (type.toLowerCase().includes('vehicle'))
    {
      return this.radar_track_filter_vehicle.checked;
    }
    else if (type.toLowerCase().includes('walker'))
    {
      return this.radar_track_filter_walker.checked;
    }
    else if (type.toLowerCase().includes('bird'))
    {
      return this.radar_track_filter_bird.checked;
    }
    else if (type.toLowerCase().includes('clutter'))
    {
      return this.radar_track_filter_clutter.checked;
    }
    else if (type.toLowerCase().includes('other'))
    {
      return this.radar_track_filter_other.checked;
    }
    else
    {
      console.log(`[is_radar_track_selected] Radar track type '${type}' not handled`);
    }
  }

  // Called by UI (pharos.pug) when the user clicks the button
  set_follow_base()
  {
    const state = !this.follow_state;

    // Do other actions here
    this.set_follow_button_state(state);
  }

  set_follow_button_state(state)
  {
    this.follow_state = state;
    this.__toggle_switch_elem(this.btn_follow, this.follow_state);
  }

  set_follow_auto_target()
  {
    this.follow_auto_target_state = !this.follow_auto_target_state;

    // Do other actions here
    this.__toggle_switch_elem(this.btn_follow_auto_target, this.follow_auto_target_state);
  }

  set_target_auto_tracking(state)
  {
    if (!this.target_source_select) return;

    if (state)
    {
      // Disable all options and only show Auto Track Radar
      Array.from(this.target_source_select[0].options).forEach(option =>
      {
        // Check if the option's text is "Auto Track"
        if (option.text !== 'Auto Track Radar')
        {
          option.disabled = true;
          option.selected = true;
        }
        else
        {
          option.disabled = false;
          option.selected = false;
        }
      });
      this.target_source_select[0].value = 'auto_track';
      this.btn_follow_auto_target.classList.remove('hidden');
    }
    else
    {
      // Diable auto track and show standard options
      Array.from(this.target_source_select[0].options).forEach(option =>
      {
        if (option.text == 'Auto Track Radar')
        {
          option.disabled = true;
        }
        else
        {
          option.disabled = false;
        }
      });
      this.target_source_select[0].value = 'manual';
    }
  }

  // Called by GUI when user changes the target source
  on_select_target_source()
  {
    this.selected_target_source = this.target_source_select.val();

    // Do other actions here
  }

  get_pharos_target_source()
  {
    return this.target_source_select.val();
  }

  // From GUI button (Radar control)
  on_start_radar()
  {
    // Do other actions here
  }

  // From GUI button (Radar control)
  on_stop_radar()
  {
    // Do other actions here
  }

  // From GUI button (SDR control)
  on_start_transmit()
  {
    const freq = $(this.input_sdr_freq).val();
    const iqrate = $(this.input_sdr_iqrate).val();
    const gain = $(this.input_sdr_gain).val();

    // Do other actions here
  }

  // From GUI button (SDR control)
  on_stop_transmit()
  {
    const freq = $(this.input_sdr_freq).val();
    const iqrate = $(this.input_sdr_iqrate).val();
    const gain = $(this.input_sdr_gain).val();

    // Do other actions here
  }

  handle_sdr_status(status)
  {
    // console.log("[handle_sdr_status]");
    // console.dir(status);

    // Utils.is_json() doesn't work for a string
    if (status && status.connected && Utils.is_json(status))
    {
      // Allow the SDR settings to be loaded once
      if (!this.sdr_initial_receieve)
      {
        $(this.input_sdr_freq).val(status.freq);
        $(this.input_sdr_iqrate).val(status.iqrate);
        $(this.input_sdr_gain).val(status.gain);

        this.sdr_initial_receieve = true;
      }

      // let online = status.online ? "Yes" : "No";
      const transmitting = status.transmitting ? 'Yes' : 'No';
      // const online_color = status.online ? 'green' : 'red';
      const transmitting_color = status.transmitting ? 'green' : 'red';

      const paused = (status.paused && status.transmit_requested) ? ' - Paused - Friendlies detected' : '';
      this.sdr_transmitting_el.innerHTML = ` Transmitting: <span style="color: ${transmitting_color};">${transmitting} ${paused}</span>`;
      // let debug = `<br> paused: ${status.paused} request: ${status.transmit_requested}`
      // this.sdr_transmitting_el.innerHTML = ` Transmitting: <span style="color: ${transmitting_color};">${transmitting} ${paused} ${debug}</span>`;
      this.sdr_status = status;
      this.control_inputs_el.removeClass('hidden');

      if (status.online)
      {
        this.sdr_emitter_container.set_online();
      }
      else
      {
        this.sdr_emitter_container.set_offline();
        this.sdr_initial_receieve = false;
      }
    }
    else
    {
      this.sdr_transmitting_el.innerHTML = ' ';
      this.control_inputs_el.addClass('hidden');

      this.sdr_emitter_container.set_offline(status);
      this.sdr_initial_receieve = false;
    }
  }

  handle_radar_status(status)
  {
    if (status && status.connected && Utils.is_json(status))
    {
      let online = status.radar_connected ? 'Yes' : 'No';
      let scanning_active = (status.system_state == 4 || status.system_state == 5) ? 'Yes' : 'No';
      let online_color = status.radar_connected ? 'green' : 'red';
      let scanning_color = (status.system_state == 4 || status.system_state == 5) ? 'green' : 'red';
      if (status.radar_running && !status.radar_connected)
      {
        online = 'Connecting...';
        online_color = 'orange';
      }
      if (status.radar_running && (status.system_state != 4 && status.system_state != 5))
      {
        if (status.radar_connected)
        {
          scanning_active = 'Starting...';
        }
        else
        {
          scanning_active = 'Connecting...';
        }
        scanning_color = 'orange';
      }
      if (status.mode == 'sim')
      {
        scanning_active = 'SIMULATED DATA...';
      }
      if (status.mode == 'rec')
      {
        if (status.radar_running)
        {
          scanning_active = '[RECORDED DATA] Running ...';
        }
        else
        {
          scanning_active = '[RECORDED DATA] Stopped';
        }
      }

      if (true)
      {
        this.radar_status_el.innerHTML = '';
        const system_state_item = this.create_status_item('System State:', `${this.radar_system_state_enum[status.system_state]}`);
        const num_tracks_item = this.create_status_item('Number of tracks:', `${status.num_tracks}`);
        system_state_item.classList.add('pharos__body-status-item--radar');
        num_tracks_item.classList.add('pharos__body-status-item--radar');
        this.radar_status_el.appendChild(system_state_item);
        this.radar_status_el.appendChild(num_tracks_item);
      }

      this.radar_scanning_el.innerHTML = `
        <div class="pharos__body-status-item--radar">
          <div class="pharos__body-status-item-title">Scanning:</div>
          <div class="pharos__body-status-item-value"><span style="color: ${scanning_color};">${scanning_active}</span></div>
        </div>
      `;

      if (status.track_class_count != undefined)
      {
        this.radar_track_filter_uav_count.innerHTML = `[${status.track_class_count.CL_UAV ? status.track_class_count.CL_UAV : 0}]`;
        this.radar_track_filter_aircraft_count.innerHTML = `[${status.track_class_count.CL_AIRCRAFT ? status.track_class_count.CL_AIRCRAFT : 0}]`;
        this.radar_track_filter_vehicle_count.innerHTML = `[${status.track_class_count.CL_VEHICLE ? status.track_class_count.CL_VEHICLE : 0}]`;
        this.radar_track_filter_walker_count.innerHTML = `[${status.track_class_count.CL_WALKER ? status.track_class_count.CL_WALKER : 0}]`;
        this.radar_track_filter_bird_count.innerHTML = `[${status.track_class_count.CL_BIRD ? status.track_class_count.CL_BIRD : 0}]`;
        this.radar_track_filter_clutter_count.innerHTML = `[${status.track_class_count.CL_CLUTTER ? status.track_class_count.CL_CLUTTER : 0}]`;
        this.radar_track_filter_other_count.innerHTML = `[${status.track_class_count.CL_OTHER ? status.track_class_count.CL_OTHER : 0}]`;
      }

      if (status.available)
      {
        this.radar_container.set_online();
      }
      else
      {
        this.radar_container.set_offline();
      }
    }
    else
    {
      this.radar_scanning_el.innerHTML = ' ';

      this.radar_container.set_offline(status);
    }
  }

  create_status_item(title, text)
  {
    const item = document.createElement('div');
    item.classList.add('pharos__body-status-item');
    const item_title = document.createElement('div');
    const item_text = document.createElement('div');

    item_title.textContent = title;
    item_text.textContent = text;

    item.appendChild(item_title);
    item.appendChild(item_text);

    return item;
  }

  toggle_body_status()
  {
    const chevron_icon = document.querySelector('.pharos__body-status-header-icon');
    chevron_icon.classList.toggle('pharos__body-status-header-icon--up');
    this.pharos_status_el.classList.toggle('pharos__body-status--closed');
  }

  toggle_body_status_target()
  {
    const chevron_icon = document.querySelector('.pharos__body-status-header-icon--target');
    chevron_icon.classList.toggle('pharos__body-status-header-icon--up');
    this.pharos_status_target_el.classList.toggle('pharos__body-status--closed');
    this.pharos_status_rssi_el.classList.toggle('pharos__body-status--closed');
  }

  update_status(status)
  {
    if (status && Utils.is_json(status))
    {
      if (status.current_pos !== null)
      {
        this.pharos_status_el.innerHTML = '';
        const lat_item = this.create_status_item('Latitude:', `${status.current_pos.lat.toFixed(7)}`);
        const lon_item = this.create_status_item('Longitude:', `${status.current_pos.lon.toFixed(7)}`);
        const alt_item = this.create_status_item('Altitude:', `${status.current_pos.alt.toFixed(1)}m`);

        const roll_item = this.create_status_item('Roll:', `${status.current_pos.roll.toFixed(1)}°`);
        const pitch_item = this.create_status_item('Pitch:', `${status.current_pos.pitch.toFixed(1)}°`);
        const yaw_item = this.create_status_item('Yaw:', `${status.current_pos.yaw.toFixed(1)}°`);
        const gps_fix_item = this.create_status_item('GPS Fix:', `${status.current_pos.gps_fix_type != undefined ? status.current_pos.gps_fix_type >= 3 ? '3D' : status.current_pos.gps_fix_type == 2 ? '2D' : 'NONE' : 'N/A'}`);
        const rtk_fix_item = this.create_status_item('RTK Fix:', `${status.current_pos.rtk_fix_type != undefined ? status.current_pos.rtk_fix_type >= 2 ? 'FIXED' : status.current_pos.rtk_fix_type == 1 ? 'FLOAT' : 'NONE' : 'N/A'}`);
        const rtk_hdg_item = this.create_status_item('RTK Heading:', `${status.current_pos.rel_pos_heading_valid ? `${status.current_pos.rel_pos_heading.toFixed(1)}° / ${status.current_pos.rel_pos_length.toFixed(2)}m` : 'INVALID'}`);

        this.pharos_status_el.appendChild(lat_item);
        this.pharos_status_el.appendChild(lon_item);
        this.pharos_status_el.appendChild(alt_item);
        this.pharos_status_el.appendChild(roll_item);
        this.pharos_status_el.appendChild(pitch_item);
        this.pharos_status_el.appendChild(yaw_item);
        this.pharos_status_el.appendChild(gps_fix_item);
        this.pharos_status_el.appendChild(rtk_fix_item);
        this.pharos_status_el.appendChild(rtk_hdg_item);
      }
      else
      {
        this.pharos_status_el.innerHTML = '';
        const pos_item = this.create_status_item('Pharos Pos:', 'N/A');
        this.pharos_status_el.appendChild(pos_item);
      }

      this.pharos_status_target_el.innerHTML = '';
      const selected_target_item = this.create_status_item('Selected Target:', `${status.selected_target ? status.selected_target : 'None'}`);
      const target_lat_item = this.create_status_item('Target Lat:', `${status.target_pos !== null && Utils.is_float(status.target_pos.lat) ? status.target_pos.lat.toFixed(7) : 'N/A'}`);
      const target_lon_item = this.create_status_item('Target Lon:', `${status.target_pos !== null && Utils.is_float(status.target_pos.lon) ? status.target_pos.lon.toFixed(7) : 'N/A'}`);
      const target_alt_item = this.create_status_item('Target Alt:', `${status.target_pos !== null && Utils.is_float(status.target_pos.alt) ? status.target_pos.alt.toFixed(1) : 'N/A'}`);
      const absolute_bearing_item = this.create_status_item('Absolute Bearing:', `${status.abs_bearing.toFixed(1)}`);
      const relative_bearing_item = this.create_status_item('Relative Bearing:', `${status.rel_yaw.toFixed(1)}`);
      const zone_name = status.activated_zone == 1 ? 'Front' : status.activated_zone == 2 ? 'Right' : status.activated_zone == 3 ? 'Back' : status.activated_zone == 4 ? 'Left' : 'None';
      const activated_zone_item = this.create_status_item('Activated Zone:', `${status.activated_zone} (${zone_name})`);
      const distance_item = this.create_status_item('Distance:', `${status.distance ? status.distance.toFixed(0) : '-'} m`);
      const adsb_confliction_item = this.create_status_item('ADS-B Confliction:', `${status.adsb_vehicles_in_sdr_zone ? `[${status.adsb_vehicles_in_sdr_zone.length}] ${status.adsb_vehicles_in_sdr_zone.map(obj => obj.icaoAddress).join(', ')}` : 'None'}`);

      this.pharos_status_target_el.appendChild(selected_target_item);
      this.pharos_status_target_el.appendChild(target_lat_item);
      this.pharos_status_target_el.appendChild(target_lon_item);
      this.pharos_status_target_el.appendChild(target_alt_item);
      this.pharos_status_target_el.appendChild(absolute_bearing_item);
      this.pharos_status_target_el.appendChild(relative_bearing_item);
      this.pharos_status_target_el.appendChild(activated_zone_item);
      this.pharos_status_target_el.appendChild(distance_item);
      this.pharos_status_target_el.appendChild(adsb_confliction_item);
      // Update target source select
      this.target_source_select[0].value = status.target_source;

      this.pharos_status_rssi_el.innerHTML = '';
      const uas_rssi_item = this.create_status_item('UAS RSSI:', `${status.uas_rssi ? status.uas_rssi.toFixed(1) : 'N/A'} dBm`);
      const gcs_rssi_item = this.create_status_item('GCS RSSI:', `${status.gcs_rssi ? status.gcs_rssi.toFixed(1) : 'N/A'} dBm`);
      this.pharos_status_rssi_el.appendChild(uas_rssi_item);
      this.pharos_status_rssi_el.appendChild(gcs_rssi_item);
    }
  }

  __on_mouse_down(e)
  {
    const origin = this.menu_handle.position().left;
    const touch = e.originalEvent.touches;
    const start = touch ? touch[0].pageX : e.pageX;

    $(window).on('mousemove touchmove', this.__on_mouse_move.bind(this, origin, touch, start));
    $(window).one('mouseup touchend', this.__on_mouse_up.bind(this));

    e.preventDefault();
  }

  __on_mouse_move(origin, touch, start, e)
  {
    const contact = e.originalEvent.touches;
    const end = touch ? contact[0].pageX : e.pageX;
    const difference = end - start;

    const newleft = Math.max(0, origin + difference);

    const newwidth = newleft + 35;

    this.menu_handle.css('left', newleft);
    this.container.css('width', newwidth);
  }

  __on_mouse_up(e)
  {
    e.preventDefault();
    $(window).off('mousemove touchmove');
    localStorage.setItem('drone_width', this.container.width());
  }

  __toggle_switch_elem(elem, should_activate)
  {
    if (should_activate)
    {
      $(elem).addClass('active');
    }
    else
    {
      $(elem).removeClass('active');
    }
  }

  update_radar_yaw_offset(element)
  {
    // clip value to 0-360
    const value = Math.max(0, Math.min(360, element.value));
    element.value = value;
    this.input_radar_yaw_offset.value = value;
    this.input_radar_yaw_offset_range.value = value;
  }

  add_sdr_receiver()
  {
    const new_receiver = new SdrReceiver(this.sdr_receivers_container);
    new_receiver.set_remove_callback(this.remove_sdr_receiver.bind(this));
    this.sdr_receivers.push(new_receiver);
  }

  remove_sdr_receiver(receiver)
  {
    const index = this.sdr_receivers.indexOf(receiver);
    if (index !== -1)
    {
      this.sdr_receivers.splice(index, 1);
    }
  }
}

export default PharosView;
